/**
 * 招待受諾APIのエラー文言。受諾導線が複数あるので1か所に集約する。
 * サーバー専用の依存を持たせないこと（クライアントからも読む）。
 */
const INVITATION_ERROR_MESSAGES: Record<string, string> = {
  "Invitation not found": "招待が見つかりません。",
  "Invitation is no longer pending": "この招待は既に完了しています。",
  "Invitation has expired": "招待の有効期限が切れています。",
  "Invitation recipient does not match signed-in user":
    "別のアカウントでログイン中です。Mazrica SalesとSozo AIの両方からログアウトしてから、招待メールのリンクをクリックし直してください。",
  "Email verification is required":
    "メールアドレスを確認してから、もう一度お試しください。",
  "User is already a member of this organization":
    "この招待は既に受諾されています。",
  "Email already belongs to another organization":
    "このアカウントは別のテナントに所属しています。",
  "User limit reached for this organization":
    "テナントのライセンス上限に達しています。管理者へお問い合わせください。",
  "Session not found":
    "ログイン状態を確認できません。再度ログインしてください。",
  Unauthorized: "ログイン状態を確認できません。再度ログインしてください。",
};

export const INVITATION_ACCEPT_FALLBACK_MESSAGE = "招待の受諾に失敗しました。";

export async function readInvitationErrorMessage(
  response: Response,
): Promise<{ message: string }> {
  const payload = (await response.json().catch(() => null)) as {
    error?: unknown;
  } | null;
  if (typeof payload?.error !== "string") {
    return { message: INVITATION_ACCEPT_FALLBACK_MESSAGE };
  }
  return {
    message:
      INVITATION_ERROR_MESSAGES[payload.error] ??
      INVITATION_ACCEPT_FALLBACK_MESSAGE,
  };
}
